import React from 'react';
import './style.css';
import {formatCurrencyByLocalChapter} from '../../../Util/commonUtility';
import useLocalization from '../../../Localization';

const CommonHeroText = ({
  heading,
  subheading,
  usedForMyEvents = false,
  userCredit,
  localChapterData,
}) => {
  const {ApplicationString} = useLocalization();
  return (
    <div
      className={`common-hero-container-wrapper ${
        usedForMyEvents ? 'common-hero-container-wrapper-myevents' : ''
      }`}>
      <div className='common-hero-text-container'>
        <span className='common-hero-text-heading'>{heading}</span>
        <span className='common-hero-text-subheading'>{subheading}</span>
      </div>

      {usedForMyEvents ? (
        <div className='common-hero-credit-container'>
          <span className='common-hero-credit-heading'>
            {ApplicationString['commonHeroText.availableCredit']}:{' '}
          </span>
          <span className='common-hero-credit-amount'>
            {localChapterData
              ? formatCurrencyByLocalChapter(userCredit, localChapterData)
              : '$0'}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default CommonHeroText;
